import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Changed Switch to Routes
import Login from './components/Login';
import Dashboard from './components/Dashboard';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          <Route exact path="/" element={token ? <Dashboard /> : <Login setToken={setToken} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;